import HistoryIcon from '@mui/icons-material/History';
import { TimelineContent } from '@mui/lab';
import { IconButton, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import SurveillanceHistoryModal from '../SurveillanceHistoryModal/SurveillanceHistoryModal';
import SurveillanceValues from '../SurveillanceValues/SurveillanceValues';
import { getExamPropertyFromWorkflow } from 'FRONTEND/components/Surveillance/utils/getExamPropertyFromWorkflow';
import { selectConsultationTenantId } from 'FRONTEND/selectors/consultationSelectors';
import { selectConsultationExamFormWithExtraFields } from 'FRONTEND/selectors/workflowSelectors';
import { useMedicineList } from 'FRONTEND/utils/hooks/useMedicineList';
import i18n from 'FRONTEND/utils/i18n';
import { useCurrentWorkflow } from 'FRONTEND/utils/nonSerializableStorage/useCurrentWorkflow';

const SurveillanceContent = ({ surveillanceEvent, showTimestamp, showOrigin }) => {
  const currentWorkflow = useCurrentWorkflow();
  // Form needed to get the labels for checkboxes and 'Scores'
  const currentForm = useSelector(state => selectConsultationExamFormWithExtraFields(state, currentWorkflow, surveillanceEvent.examName));
  const currentConsultationTenantId = useSelector(selectConsultationTenantId);

  const medicineList = useMedicineList(currentForm, surveillanceEvent.type, currentConsultationTenantId);
  const [isSurveillanceHistoryModalOpen, setIsSurveillanceHistoryModalOpen] = useState(false);
  const hasHistory = surveillanceEvent.modificationHistory.length > 1;

  if (!surveillanceEvent.values || !currentForm) {
    return null;
  }

  return (
    <TimelineContent
      sx={{
        py: 1,
        px: 2,
        backgroundColor: (theme) => theme.palette.common.white,
        borderRadius: '15px',
        gap: 1,
        marginY: 2,
        marginLeft: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Stack sx={{ width: '100%' }}>
        <Typography variant='h5' sx={{ display: 'flex', alignItems: 'center', color: (theme) => theme.palette.primary.light }}>
          {showOrigin && (getExamPropertyFromWorkflow({ examId: surveillanceEvent.origin, workflow: currentWorkflow, targetedProperty: 'label' }) + ' - ' || i18n._('Surveillance') + ' - ')}
          {getExamPropertyFromWorkflow({ examId: surveillanceEvent.examName ?? i18n._(surveillanceEvent.examName), workflow: currentWorkflow, targetedProperty: 'label' }) ?? surveillanceEvent.examName}
          {hasHistory && (
            <IconButton sx={{ ml: '10px' }} aria-label='delete' onClick={() => setIsSurveillanceHistoryModalOpen(true)}>
              <HistoryIcon sx={{ color: 'black' }} />
            </IconButton>
          )}
        </Typography>
        {showTimestamp && (
          <Typography sx={{ fontWeight: 'bold' }}>
            {dayjs(surveillanceEvent.date).format('HH:mm:ss')}
          </Typography>
        )}
        <SurveillanceValues
          surveillanceEvent={surveillanceEvent}
          currentForm={currentForm}
          medicineList={medicineList}
          dense
        />
        {surveillanceEvent.deletedByUser && (
          <Typography sx={{ textAlign: 'right', color: (theme) => theme.palette.primary.light, fontSize: '15px' }}>
            {`${surveillanceEvent.deletedByUser.firstName} ${surveillanceEvent.deletedByUser.lastName}`}
          </Typography>)}
      </Stack>
      <SurveillanceHistoryModal
        isModalOpen={isSurveillanceHistoryModalOpen}
        surveillanceData={surveillanceEvent}
        currentForm={currentForm}
        medicineList={medicineList}
        handleClose={() => setIsSurveillanceHistoryModalOpen(false)}
      />
    </TimelineContent>
  );
};

export default SurveillanceContent;
